import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DataTableDynamic from '../../../../component/Table/DataTableDynamic';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { getToken } from '../../../../helpers/Jwt';
import DataTablePageDynamic from '../../../../component/Table/DataTablePageDynamic';

const HistoryReservation = () => {
    const navigate = useNavigate();
    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const [data, setData] = useState([]);
    const [isNextPage, setIsNextPage] = useState(true);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_RESERVATION = "api/kejati/dashboard/reservation";

    // Fetch data from the API
    const fetchData = async (URL, config) => {
        try {
            const response = await axios.get(URL, config);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_RESERVATION}`, {
            params: {
                offset: pageIndex,
                limit: pageSize
            },
            headers: {
                Authorization: `Bearer ${getToken()}`,
                "Content-Type": "application/json"
            }
        }).then((data) => {
            setData(data.data);
        });
    }, []);

    useEffect(() => {
        setKeys(data.length > 0 ? Object.keys(data[0]) : []);
    }, [data]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    const handleDetail = (rowData) => {
        navigate(`/activity-kejati/reservation/detail/${rowData.id.value}`);
    };

    const actions = [{
        child: <button className='text-white text-xs rounded focus:ring bg-blue-500 hover:bg-blue-700 p-2 mx-1'>
            <FontAwesomeIcon icon={faInfo} color="white" />nfo
        </button>,
        callback: (rowData) => handleDetail(rowData)
    }];

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <div className='flex items-center justify-between px-5'>
                <h1>Reservasi</h1>
            </div>

            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                <DataTablePageDynamic
                    data={data}
                    nextPage={isNextPage}
                    columns={columns}
                    elementClass="p-1"
                    actions={actions}
                    onDataChange={(pageIndex, pageSize, sortBy) => {
                        fetchData(`${BASE_URL}${PATH_RESERVATION}`, {
                            params: {
                                offset: pageIndex,
                                limit: pageSize
                            },
                            headers: {
                                Authorization: `Bearer ${getToken()}`,
                                "Content-Type": "application/json"
                            }
                        }).then((data) => {
                            setIsNextPage(data.more > 0);
                            setData(data.data);
                        });
                    }} />
            )}
        </div>
    )
}

export default HistoryReservation;
